import { LANDING_MORE } from "@/pages/home/landingContent";

interface LandingMoreLinkProps {
  className?: string;
}

/** "¿Querés saber más del producto? Conocé más": enlace externo al sitio de ADF, en otra pestaña. */
export function LandingMoreLink({ className }: LandingMoreLinkProps) {
  return (
    <p className={`flex flex-wrap items-center gap-x-1 text-sm text-white/90 ${className ?? ""}`}>
      {LANDING_MORE.prompt}
      <a
        href={LANDING_MORE.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={LANDING_MORE.ariaLabel}
        className="inline-flex min-h-11 items-center rounded-sm px-1 font-semibold text-white underline underline-offset-3 outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {LANDING_MORE.label}
      </a>
    </p>
  );
}
